var Decimal = require('decimal.js');
Decimal.set({
	precision: 13,
	rounding: 2
})
export default {
	install(Vue, options) {
		Vue.prototype.$add = function(a, b) {
			a = Number(a)
			b = Number(b)
			return new Decimal(a).plus(b).toString()
		}

		Vue.prototype.$sub = function(a, b) {
			a = Number(a)
			b = Number(b)
			return new Decimal(a).minus(b).toString()
		}

		Vue.prototype.$mul = function(a, b) {
			a = Number(a)
			b = Number(b)
			return new Decimal(a).times(b).toString()

		}

		Vue.prototype.$div = function(a, b) {
			a = Number(a)
			b = Number(b)	
			return new Decimal(a).div(b).toString()
		}
	}
}


// WEBPACK FOOTER //
// ./utils/textFormat.js